export const isHtmlElement = (obj: unknown): obj is HTMLElement => obj instanceof HTMLElement;
